<template>
    <div
        class="good-bad"
        :class="{
            disabled: isUpdating,
            'good-bad--right': isAlignRight,
            'to-disabled': isDisabled,
        }"
    >
        <!-- good zone -->
        <div class="good" @click="onClickGood">
            <img
                class="finger-image-box hover-setting1"
                :src="
                    '/img/' +
                    (isGoodPushed
                        ? 'good-finger-selected.png'
                        : 'good-finger.png')
                "
            />
            <a class="evaluation-text" :class="{ toBold: isGoodPushed }"
                >いいね！</a
            >
            <a class="evaluation-count">{{ store.state.goodCount }}</a>
        </div>
        <div class="bad" @click="onClickBad">
            <!-- bad zone -->
            <img
                class="finger-image-box hover-setting1"
                @click="onClickBad"
                :src="
                    '/img/' +
                    (isBadPushed ? 'bad-finger-selected.png' : 'bad-finger.png')
                "
            />
            <a class="evaluation-text" :class="{ toBold: isBadPushed }"
                >ばっど！</a
            >
            <a class="evaluation-count">{{ store.state.badCount }}</a>
        </div>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent, inject, onMounted } from "vue";

export default defineComponent({
    props: {
        goodCount: Number,
        badCount: Number,
        endpoint: String,
        isAlignRight: Boolean,
        isDisabled: Boolean,
    },
    setup(props, context) {
        const store = inject("store");
        onMounted(() => {
            store.setGoodCount(props.goodCount);
            store.setBadCount(props.badCount);
            store.setEndpoint(props.endpoint);
            // Localstrage取得
            store.setInitialState();
        });

        const isGoodPushed = computed(() => store.state.isGoodPushed);
        const isBadPushed = computed(() => store.state.isBadPushed);
        const isUpdating = computed(() => store.state.isUpdating);

        const onClickGood = () => {
            store.pushGoodCount();
        };
        const onClickBad = () => {
            store.pushBadCount();
        };

        return {
            store,
            onClickGood,
            onClickBad,
            isGoodPushed,
            isBadPushed,
            isUpdating,
        };
    },
});
</script>

<style lang="scss" scoped>
.disabled {
    opacity: 0.5;
}
.good-bad {
    display: flex;
}
.bad {
    margin-left: 10px;
}
</style>
